import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import moment from 'moment';
import Base from '../js/base';
import Utils from '../js/utils';
import Hh from '../js/huyhieu';
export default (function (props, _ref) {
  var $ = _ref.$,
      $on = _ref.$on,
      $f7 = _ref.$f7,
      $update = _ref.$update;
  var month = moment().format('YYYY-MM'); //Mặc định là tháng này

  var page_name = 'huyhieu-form';
  var pn = "div[data-name=\"".concat(page_name, "\"]");
  var totalPoints = 0; //Khi người dùng thay đổi tháng trao tặng

  var monthChange = function monthChange(e) {
    month = $(e.target).val(); //Đảm bảo tất cả các huy hiệu được bỏ check và reset về 0

    $(pn + ' .available-huyhieu span.qty').text(0);
    $(pn + ' .available-huyhieu input[type="radio"]').prop("checked", false); //Set lại số huy hiệu của tháng trước

    Hh.getWallet(month, function () {
      return showAvailables();
    });
    setNum(0);
  }; //Ẩn các huy hiệu mà user không có


  var showAvailables = function showAvailables() {
    //Nếu ví rỗng, ẩn toàn bộ loại huy hiệu
    if (Hh.myWallet === null || Hh.myWallet.rows.length === 0) return;
    $(pn + ' .available-huyhieu').removeClass('display-none');
    totalPoints = 0;
    Hh.myWallet.rows.forEach(function (row) {
      totalPoints += row.qty;
    });
    $update();
  }; //Hàm lấy số huy hiệu hiện thời để trao tặng


  var getNum = function getNum() {
    return Utils.str2Num($(pn + ' .num').text());
  }; //Set num


  var setNum = function setNum(num) {
    return $(pn + ' .num').text(num);
  }; //Trừ


  var minus = function minus(e) {
    var num = getNum();
    if (num === 0) return;
    num--;
    setNum(num);
  }; //Cộng


  var plus = function plus(e) {
    var num = getNum();
    num++;

    if (num > totalPoints) {
      num = totalPoints;
      $f7.dialog.alert('Quá số điểm khả dụng');
    }

    setNum(num);
  }; //Chọn đồng nghiệp


  var addUser = function addUser(user) {
    //Kiểm tra danh sách đã tồn tại user chưa
    if ($(pn + " .user-rows .row[data-id=\"".concat(user.id, "\"]")).length > 0) return; //Không add chính bản thân mình vào danh sách tri ân

    if (user.id === Base.user.id) return; //Thêm vào danh sách

    var $row = $("<div class=\"row\" data-id=\"".concat(user.id, "\"><span>").concat(user.name, "</span> <a class=\"remove\" style=\"font-size: 16px; margin-right: 5px;\"><i class=\"f7-icons icon\" style=\"font-size: 16px;\">minus_square_fill</i></a></div>"));
    $row.find('.remove').click(function (e) {
      $row.remove();
    });
    $(pn + ' .user-rows').append($row);
  }; //Click nút tri ân 


  var thanks = function thanks() {
    //Lấy số huy hiệu
    var num = getNum();

    if (num === 0) {
      $f7.dialog.alert('Chưa chọn số điểm');
      return;
    }

    if ($(pn + ' .user-rows .row').length === 0) {
      $f7.dialog.alert('Chưa chọn người cảm ơn');
      return;
    }

    var receivers = [];
    $(pn + ' .user-rows .row').each(function () {
      var id = Utils.str2Num($(this).data('id'));
      receivers.push(id);
    }); //Kiểm tra số huy hiệu khả dụng cho TỪNG người
    //Số lượng người được tặng

    var totalReceivers = receivers.length;

    if (num * totalReceivers > totalPoints) {
      $f7.dialog.alert("Kh\xF4ng \u0111\u1EE7 ".concat(num, "  \u0111i\u1EC3m \u0111\u1EC3 t\u1EB7ng t\u1EEBng ng\u01B0\u1EDDi (").concat(num, "x").concat(totalReceivers, "=").concat(num * totalReceivers, ")"));
      return;
    } //Kết thúc kiểm tra số huy hiệu khả dụng cho TỪNG người


    var message = $(pn + ' textarea[name="message"]').val().trim();

    if (message === '') {
      $f7.dialog.alert('Chưa viết lời khen thưởng');
      return;
    } //Lấy tháng trao tặng


    var month = $(pn + ' select[name="giving-month"]').val();
    $f7.dialog.confirm('Xác nhận?', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var dialog, data, rs;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dialog = $f7.dialog.preloader();
              data = {
                num: num,
                receivers: receivers,
                month: month,
                message: message
              };
              _context.next = 4;
              return Base.api('Huyhieu', 'postTransaction', data);

            case 4:
              rs = _context.sent;
              dialog.close(); //Update wallet

              Hh.getWallet(month, function () {
                return showAvailables();
              }); //Clear form

              setNum(0);
              $(pn + ' input[name="receivers"]').val('');
              $(pn + ' .user-rows').html('');
              $(pn + ' textarea[name="message"]').val('');
              $f7.dialog.alert('Đã khen thưởng đến đồng nghiệp!');

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
  };

  $on('pageAfterIn', function () {
    //Kiểm tra ví
    if (Hh.myWallet === null) {
      Hh.getWallet(month, function () {
        return showAvailables();
      });
    } else {
      showAvailables();
    } //Sự kiện tìm kiếm người dùng


    $(pn + ' input[name="receivers"]').change(function (e) {
      //Lấy chuỗi tìm kiếm
      var s = $(e.target).val(); //Chỉ tìm kiếm khi độ dài > 2

      if (s.length < 2) return; //Chuyển sang chữ thấp và bỏ dấu

      var ss = Utils.removeVietnameseTones(s.toLowerCase());
      var users = Base.initdata.emps.filter(function (u) {
        if (u.deleted === null || u.deleted === 0) {
          var phone = u.phone;
          var name = Utils.removeVietnameseTones(u.name.toLowerCase()); //Nếu tìm thấy SDT phù hợp

          if (phone.indexOf(ss) !== -1) return u; //Nếu tìm thấy tên phù hợp

          if (name.indexOf(ss) !== -1) return u;
        }
      }); //Nếu mảng users rỗng, Hiện thông báo

      if (users.length === 0) {
        $f7.dialog.alert('Không tìm thấy đồng nghiệp nào');
        return;
      } //Nếu tìm thấy, thêm vào danh sách


      users.forEach(function (u) {
        return addUser(u);
      }); //Clear input

      $(e.target).val('');
    }); //Nếu thay đổi loại huy hiệu, số huy hiệu trao đi được reset=0;

    $(pn + " .available-huyhieu input").click(function (e) {
      return setNum(0);
    });
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="${page_name}">

  <div class="toolbar toolbar-bottom">
    <div class="toolbar-inner">
      <a class="button button-fill" @click=${thanks}>Khen thưởng</a>
    </div>
  </div>
  <div class="page-content">

    <div class="list no-margin no-hairlines">
      <ul>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">Điểm khen thưởng được tính cho</div>
            <div class="item-input-wrap input-dropdown-wrap">
              <select name="giving-month" @change="${monthChange}">
                  <option value="${moment().format('YYYY-MM')}">Tháng này - ${moment().format('M/YYYY')}</option>
                  <option value="${moment().subtract(1, 'months').format('YYYY-MM')}">Tháng trước - ${moment().subtract(1, 'months').format('M/YYYY')}</option>
              </select>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div class="no-margin no-hairlines available-huyhieu display-none">
      <div class="list no-margin no-hairlines">
        <ul>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">Số điểm khả dụng</div>
              <div class="item-input-wrap">
                <input type="text" name="avail-point" readonly value="${totalPoints}" />
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="block row thanks-num margin-half">
      <div class="col text-align-right calc-button margin-top"><a @click=${minus}><i class="f7-icons icon" style="font-size: 30px;">minus_circle_fill</i></a></div>
      <div class="col text-align-center num" style="color: rgb(255, 255, 255); font-size: 40px; font-weight: bold;">0</div>
      <div class="col text-align-left calc-button margin-top"><a @click=${plus}><i class="f7-icons icon" style="font-size: 30px;">plus_circle_fill</i></a></div>
    </div>

    <div class="list no-margin no-hairlines">
      <ul>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">Bạn muốn khen thưởng ai?</div>
            <div class="item-input-wrap">
              <input type="text" name="receivers" placeholder="Gõ tên hoặc SDT" />
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div class="block user-rows no-margin"></div>

    <div class="list no-margin no-hairlines">
      <ul>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-input-wrap">
              <textarea name="message" placeholder="Bạn khen thưởng (những) đồng nghiệp ở trên vì điều gì?"></textarea>
            </div>
          </div>
        </li>
      </ul>
    </div>

  </div>
</div>
`
    }
    ;
});